export default __webpack_public_path__ + "static/media/Tunic of the Faceless Sphinx.34a8d3eb.jpg";